var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "billboard",
    class: {
      'showTooltip': _vm.hovering
    },
    attrs: {
      "id": "million-bit-billboard"
    },
    on: {
      "click": _vm.clickBillboard,
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousemove": _vm.onMouseMove
    }
  }, [_c('canvas', {
    attrs: {
      "id": "uploadedImg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.s3ImgSrc,
      "usemap": "#linkmap"
    },
    on: {
      "load": _vm.onBillboardLoaded
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "linkmap"
    }
  }, _vm._l((_vm.links), function(link) {
    return _c('area', {
      attrs: {
        "target": "_blank",
        "alt": "",
        "title": "",
        "shape": "rect",
        "coords": link.c,
        "href": link.u
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    ref: 'tooltip',
    attrs: {
      "id": "billboard-tooltip"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b675e1ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preme.vue
// module id = xySY
// module chunks = 2